<!--
    描述：角色列表
    日期：2021/04/08
    作者：zwh
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>角色列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   icon="el-icon-circle-plus"
							   v-if="roleBtns.includes('role_plus_add')"
							   size="small"
							   @click="doClick('','add')">新增</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="tableContent">
						<el-table :data="treeData.tableData"
								  row-key="id"
								  v-loading="treeData.loading"
								  ref="menusTree"
								  default-expand-all
								  :height="treeData.tableH"
								  border
								  highlight-current-row
								  @row-click="rowClick"
								  :tree-props="{children: 'children'}">
							<el-table-column prop="roleName"
											 label="角色名称"
											 header-align="center"
											 align="center"
											 show-overflow-tooltip
											 min-width="100"></el-table-column>
							<el-table-column prop="roleTypeName"
											 label="角色类型"
											 header-align="center"
											 align="center"
											 show-overflow-tooltip
											 min-width="80">
								<template slot="header"
										  slot-scope="scope">
									<div>角色类型
										<el-tooltip effect="light"
													placement="top">
											<div slot="content">
												创建角色时指定角色类型以适配于项目管理系统作业内外角色权限。</br>
												项目外公共角色：管理员创建，用于项目管理系统操作权限。
											</div>
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
								</template>
								<template slot-scope="scope">
									<span
										  v-show="scope.row.roleType ==='1003001' && scope.row.limitId == null">项目外公共角色</span>
									<span
										  v-show="scope.row.roleType ==='1003001' && scope.row.limitId != null">项目外主体公共角色</span>
									<span v-show="scope.row.roleType ==='1003002'">项目外主体私有角色</span>
								</template>
							</el-table-column>
							<el-table-column prop="limitName"
											 label="主体类型"
											 v-if="userInfo.roleType === 1"
											 header-align="center"
											 align="center"
											 show-overflow-tooltip
											 min-width="80"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 width="100">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   v-if="roleBtns.includes('role_plus_edit') && !scope.row.readOnly"
											   type="text"
											   :disabled="scope.row.roleType === '1003001' && userInfo.roleType !== 1"
											   @click.stop.prevent="doClick(scope.row,'edit')"></el-button>
									<el-button v-if="roleBtns.includes('role_plus_delete') && !scope.row.readOnly "
											   size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   :disabled="scope.row.roleType === '1003001' && userInfo.roleType !== 1"
											   @click.stop.prevent="doClick(scope.row,'delete')"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<addRole ref="addRole"
					 v-if="dialogObj.visible"
					 :mode="dialogObj.mode"
					 :transObj="transObj"
					 @handle-success="handleSuccess"></addRole>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import addRole from './add_role_dialog'
import { getRoleList, deletePlus } from 'api/system/role.js'
export default {
	name: '',
	components: {
		addRole,
	},
	data() {
		return {
			//子组件传递对象
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: '',
			},

			btnLoading: false,
			//弹框对象
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add',
			},
			treeData: {
				loading: false,
				tableH: 200,
				tableData: [],
			},
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeData.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
	watch: {
		clientSize(val) {
			this.treeData.tableH = this.$refs.tableContent.offsetHeight
		},
	},
	created() {
		//获取角色列表信息
		this.getRoleList()
	},
	methods: {
		//获取角色列表信息
		getRoleList() {
			let that = this
			let param = {
				//tenantId : getItem('tenantId'),
				//limitId : getItem('limitId')
			}
			getRoleList(param).then((res) => {
				that.treeData.tableData = res.data

				if (this.treeData.tableData.length > 0) {
					this.rowClick(this.treeData.tableData[0])
					this.$refs.menusTree.setCurrentRow(
						this.treeData.tableData[0]
					)
				}
			})
		},
		//行点击
		rowClick(obj) {
			this.$emit('row-click', obj)
		},
		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			let that = this
			that.dialogObj.mode = type
			if (type === 'add') {
				//新增
				this.transObj.id = ''
				if (obj != '') {
					//新增子角色
					that.transObj.type = 'addSon'
					this.transObj.parentId = obj.id
					this.transObj.parentName = obj.roleName
				} else {
					//新增父角色
					that.transObj.type = 'addParent'
					this.transObj.parentId = '0'
					this.transObj.parentName = ''
				}
				this.dialogObj.title = '新增角色'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				//编辑
				that.transObj.type = 'edit'
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑角色'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				//删除
				this.delete(obj)
			}
		},
		//删除
		delete(obj) {
			let that = this
			this.$confirm(
				'删除角色信息，将会删除角色菜单、角色菜单按钮、权限数据等信息，确认删除吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				let param = {
					id: obj.id,
				}
				deletePlus(param).then((res) => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getRoleList()

						let obj = {
							id: '',
							roleName: '',
						}
						this.$emit('row-click', obj)
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		// 确定按钮事件
		doSave() {
			this.btnLoading = true
			this.$refs.addRole.doSave()
			setTimeout(() => {
				this.btnLoading = false
			}, 2000)
		},
		//新增/编辑菜单成功
		handleSuccess() {
			this.dialogObj.visible = false
			this.getRoleList()
		},
		// 关闭弹窗事件
		handleClose() {},
	},
}
</script>
<style lang="less">
</style>